{
    "coordinates": [
        55.98526602415578,
        -4.276740929709632
    ],
    "tooltip": "Ballagan",
    "title": "Ballagan",
    "country": "Scotland, England (UK)",
    "period": "Carboniferous",
    "alt": "TODO"
}
